// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3932L","label":"styles_label__14NbE"};